module.exports = __webpack_public_path__ + "img/DNADamage-OVCA_10X_TPCP.cf0d2252.png";